import React, { Component } from 'react'

export default class Blog extends Component {
	render() {
		return (
			<div>
				<div className="colorlib-narrow-content">
					<div className="row">
						<div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
							<span className="heading-meta">Read</span>
							<h2 className="colorlib-heading">Blogs</h2>
						</div>
						<div className="col-md-6 animate-box" data-animate-effect="fadeInLeft">
							<a href="https://liz2020.github.io/blogs/" className="btn btn-primary">Go to blog site </a>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
